/* eslint-disable import/prefer-default-export */
import { listFragment } from 'legacy/graphql/fragments/primitives/listFragment';
import { textBlockSimpleFragment } from 'legacy/graphql/fragments/sections/textBlockFragment';

/**
 * @type {string}
 */
export const keyTakeawaysFragment = listFragment(textBlockSimpleFragment, 10);
